export const FONTELLO_FONTAWESOME_BASKET = {
    xlinkHref: '#fontello-fontawesome-basket',
    viewBox: '0 0 928.6 1000'
};

export const FONTELLO_FONTAWESOME_HEART = {
    xlinkHref: '#fontello-fontawesome-heart',
    viewBox: '0 0 1000 1000'
};

export const FONTELLO_FONTAWESOME_STAR = {
    xlinkHref: '#fontello-fontawesome-star',
    viewBox: '0 0 928.6 1000'
};

export const FONTELLO_FONTAWESOME_STAR_EMPTY = {
    xlinkHref: '#fontello-fontawesome-star-empty',
    viewBox: '0 0 928.6 1000'
};

export const FONTELLO_FONTAWESOME_STAR_HALF_ALT = {
    xlinkHref: '#fontello-fontawesome-star-half-alt',
    viewBox: '0 0 928.6 1000'
};

export const ICON_DOWN_ARROW = {
    xlinkHref: '#icon-down-arrow',
};

export const FONTELLO_MODERNPICS_OK = {
    xlinkHref: '#fontello-modernpics-ok',
    viewBox: '0 0 875 1000'
};

export const ICON_REFRESH = {
    xlinkHref: '#icon-refresh',
};

export const FONTELLO_ENTYPO_CANCEL_CIRCLED = {
    xlinkHref: '#fontello-entypo-cancel-circled',
    viewBox: '0 0 840 1000'
};

export const FONTELLO_MFGLABS_SEARCH = {
    xlinkHref: '#fontello-mfglabs-search',
    viewBox: '0 0 892.578 1000'
};
